// Product card colour selection, including dynamically loaded cards.

const colourSwatchOriginalImages = new WeakMap();

document.addEventListener("click", (event) => {
	const swatch = event.target.closest("[data-master-colour-swatch]");

	if (!swatch || event.defaultPrevented) return;

	// Preserve opening the swatch's product in another tab or window.
	if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

	const lookCard = swatch.closest(".complete-look-card");
	if (lookCard) {
		// Use the same delegated click handling as PLP cards, including editor reloads.
		event.preventDefault();
		if (lookCard.dataset.lookProductId === swatch.dataset.productId) return;
		if (lookCard.querySelector("[data-look-add].is-loading")) return;

		const template = swatch.querySelector("[data-complete-look-colour-card]");
		const colourCard = template?.content.querySelector(".complete-look-card");
		if (!colourCard) {
			const message = lookCard.querySelector("[data-look-message]");
			if (message) {
				message.textContent = lookCard.dataset.lookColourError;
				message.classList.add("is-error");
			}
			return;
		}

		const replacement = colourCard.cloneNode(true);
		// Preserve the original colour family, even when sibling products have no swatch metafield.
		const swatches = swatch.closest(".product-block-options--master-colours");
		replacement.querySelector("[data-look-swatches-slot]").replaceWith(swatches);
		swatches.querySelectorAll("[data-master-colour-swatch]").forEach((item) => {
			const selected = item === swatch;
			item.classList.toggle("product-block-options__item--active", selected);
			if (selected) {
				item.setAttribute("aria-current", "true");
			} else {
				item.removeAttribute("aria-current");
			}
		});
		lookCard.replaceWith(replacement);
		replacement.dispatchEvent(new CustomEvent("complete-look:card-changed", { bubbles: true }));
		const rating = replacement.querySelector(".product-card-rating-slot [data-oke-star-rating]");
		if (rating && window.okeWidgetApi?.initWidget) {
			window.okeWidgetApi.initWidget(rating);
		}
		replacement.querySelector(`[data-master-colour-swatch][data-product-id="${swatch.dataset.productId}"]`)?.focus({ preventScroll: true });
		return;
	}

	const productBlock = swatch.closest("product-block");
	const productUrl = swatch.dataset.productUrl;

	if (!productBlock || !productUrl) return;

	event.preventDefault();

	if (!colourSwatchOriginalImages.has(productBlock)) {
		colourSwatchOriginalImages.set(
			productBlock,
			Array.from(productBlock.querySelectorAll(".product-block__image img"), (image) => ({
				image,
				src: image.getAttribute("src") || image.getAttribute("data-manual-src"),
				srcset: image.getAttribute("srcset") || image.getAttribute("data-manual-srcset"),
				alt: image.getAttribute("alt"),
			}))
		);
	}

	const isOriginalColour = swatch.dataset.productId === productBlock.dataset.productId;

	for (const original of colourSwatchOriginalImages.get(productBlock)) {
		if (!isOriginalColour && !swatch.dataset.productImage) continue;

		// Prevent deferred image loading from replacing the selected colour later.
		original.image.removeAttribute("data-manual-src");
		original.image.removeAttribute("data-manual-srcset");

		const attributes = isOriginalColour
			? original
			: {
					src: swatch.dataset.productImage,
					srcset: null,
					alt: swatch.dataset.productTitle,
				};

		for (const attribute of ["src", "srcset", "alt"]) {
			if (attributes[attribute] == null) {
				original.image.removeAttribute(attribute);
			} else {
				original.image.setAttribute(attribute, attributes[attribute]);
			}
		}
	}

	productBlock.querySelectorAll(".product-link, .quickbuy-toggle").forEach((link) => {
		link.setAttribute("href", productUrl);
	});

	const price = productBlock.querySelector(".product-price--block");
	const priceTemplate = swatch.querySelector("[data-colour-swatch-price]");

	if (price && priceTemplate) {
		price.replaceChildren(priceTemplate.content.cloneNode(true));
	}

	const ratingSlot = productBlock.querySelector(".product-card-rating-slot");
	const ratingTemplate = swatch.querySelector("[data-colour-swatch-rating]");

	if (ratingSlot && ratingTemplate) {
		ratingSlot.replaceWith(ratingTemplate.content.cloneNode(true));
		const selectedRating = productBlock.querySelector(".product-card-rating-slot [data-oke-star-rating]");
		if (selectedRating && window.okeWidgetApi?.initWidget) {
			window.okeWidgetApi.initWidget(selectedRating);
		}
	}

	const imageLabelWrap = productBlock.querySelector(".image-label-wrap");
	const labelsTemplate = swatch.querySelector("[data-colour-swatch-labels]");

	if (imageLabelWrap && labelsTemplate && !productBlock.classList.contains("product-block--compact")) {
		imageLabelWrap.querySelector(".product-label-container")?.remove();
		imageLabelWrap.append(labelsTemplate.content.cloneNode(true));
	}

	productBlock.querySelectorAll("[data-master-colour-swatch]").forEach((item) => {
		const isSelected = item === swatch;
		item.classList.toggle("product-block-options__item--active", isSelected);
		if (isSelected) {
			item.setAttribute("aria-current", "true");
		} else {
			item.removeAttribute("aria-current");
		}
	});
});
